import jwt from 'jsonwebtoken'
import _ from 'lodash'
import getConfig from 'next/config'

export const groupElements = elements => {
  const nestedElements = {}
  const defaultPath = ['Reportz', 'My Reportz Reports']
  const updatedElements = elements.map(element => {
    const elementPath = element.path !== [] ? element.path : null
    const path = elementPath || [...defaultPath, element.parent_id]
    const cleanPath = []
    for (const i of path) {
      i && cleanPath.push(i)
    }
    return {
      ...element,
      path: cleanPath,
    }
  })
  const groupedElements = _.groupBy(updatedElements, 'path')
  _.each(groupedElements, (items, path) => {
    _.set(nestedElements, path.split(','), items)
  })
  return nestedElements
}

export const validateToken = () => {
  const { AUTH0_CLIENT_ID, AUTH0_CLIENT_PUBLIC_KEY } = getClientConfig()
  const options = {
    audience: AUTH0_CLIENT_ID,
  }
  const token = localStorage.getItem('idToken')
  return jwt.verify(token, AUTH0_CLIENT_PUBLIC_KEY, options, (verifyError, decoded) => {
    if (verifyError) {
      return null
    }
    return { ...decoded, isAuthenticated: !!decoded }
  })
}

export const getClientConfig = () => {
  const config = getConfig()
  const { publicRuntimeConfig } = config
  return publicRuntimeConfig
}

export const getServerConfig = () => {
  const config = getConfig()
  const { serverRuntimeConfig } = config
  return serverRuntimeConfig
}

export const urlGetters = {
  Reportz: id => `https://reportz-staging.mntd.net/report/element/goto/${id}`,
  Looker: params => {
    return fetch(
      `${LOOKER_URL_API}?destination=${params}&token=${localStorage.getItem('accessToken')}`
    )
      .then(res => res.json())
      .then(data => data.url)
  },
  Sheets: id => `https://docs.google.com/spreadsheets/d/${id}`,
}
